export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "footer_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Conditions générales d’utilisation de vos login et mot de passe"])},
        "footer_description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vous reconnaissez expressément le caractère confidentiel des identifiants login et mot de passe qui vous ont été communiqués pour accéder à la base de données Nomination. Par conséquent, vous vous interdisez formellement tout prêt, cession, commercialisation même à titre gratuit de vos identifiants ; vous serez tenu(e) responsable de tout agissement contraire au droit qui pourrait être commis à l’aide de vos identifiants."])}
      },
      "en": {
        
      }
    }
  })
}
